import React, { useCallback } from 'react';
import { isNil } from 'lodash';
import {
  useListContext,
  useNotify,
  useRefresh,
  useUpdate,
} from 'react-admin';
import { AssignButton } from '../components/CaseAssign';
import useDialogStatus from '../../../hooks/useDialogStatus';
import { ICase } from '../../../utilities/schemas/case';

const BulkAssign = () => {
  const { data, selectedIds, onUnselectItems } = useListContext<ICase>();
  const notify = useNotify();
  const refresh = useRefresh();
  const { open, openDialog, closeDialog } = useDialogStatus();

  const filteredIds = selectedIds.filter((selectedId) => (
    data?.find((item) => item.id === selectedId)
    && isNil(data?.find((item) => item.id === selectedId)?.assignment?.memberId)
  ));
  const filteredOutIds = selectedIds.filter((selectedId) => !(
    data?.find((item) => item.id === selectedId)
    && isNil(data?.find((item) => item.id === selectedId)?.assignment?.memberId)
  ));

  const [update] = useUpdate();
  const handleSubmit = useCallback(({
    newAssignment,
  }: { newAssignment?: string }) => {
    update(
      'cases',
      { id: '/bulk-assign', data: { newAssignment, caseIds: filteredIds } },
      {
        onSuccess: () => {
          onUnselectItems();
          closeDialog();
          notify('Cases assignments have been updated');
          refresh();
        },
        onError: () => {
          notify('Could not assign cases. This might be because someone else has already assigned the case.', { type: 'error' });
          refresh();
        },
      },
    );
  }, [update, filteredIds, onUnselectItems, notify, refresh, closeDialog]);

  return (
    <AssignButton
      handleSubmit={handleSubmit}
      open={open}
      openDialog={openDialog}
      closeDialog={closeDialog}
      filteredOutIds={filteredOutIds}
      filteredIds={filteredIds}
      isBulkAssign
    />
  );
};

export default BulkAssign;
